import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getSageDepartment(id) {
    return Repository.get(`${resource}/sage_departments/${id}`)
  },
  getListOfSageDepartments(pageNumber = 1, filterQuery, pagination = defaultPagination, is_paginate = 1) {
    return Repository.get(`${resource}/sage_departments?paginate=${pagination}&page=${pageNumber}&${filterQuery}&is_paginate=${is_paginate}`)
  },
  updateSageDepartment(id, payload) {
    return Repository.put(`${resource}/sage_departments/${id}`, payload)
  },
  createSageDepartment(payload) {
    return Repository.post(`${resource}/sage_departments`, payload)
  },
  deleteSageDepartment(id) {
    return Repository.delete(`${resource}/sage_departments/${id}`)
  },

  getListOfSageNominalCodes(pageNumber = 1, filterQuery, pagination = defaultPagination, is_paginate = 1) {
    return Repository.get(`${resource}/sage_nominal_codes?paginate=${pagination}&page=${pageNumber}&${filterQuery}&is_paginate=${is_paginate}`)
  },
  getSageNominalCode(id) {
    return Repository.get(`${resource}/sage_nominal_codes/${id}`)
  },
  createSageNominalCode(payload) {
    return Repository.post(`${resource}/sage_nominal_codes`, payload)
  },
  updateSageNominalCode(id, payload) {
    return Repository.put(`${resource}/sage_nominal_codes/${id}`, payload)
  },
};
